import { useState } from 'react';
import { CalendarDays } from 'lucide-react';
import { formatDate } from '../../lib/utils';
import { localDate } from '../../lib/tyreReports';
import { Button } from './button';
import { Calendar } from './calendar';
import { Popover, PopoverContent, PopoverTrigger } from './popover';

export const DatePicker = ({ id, label, value, onChange, invalid, describedBy }) => {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(`${value}T00:00:00`) : undefined;
  const selectDate = (date) => {
    if (!date) return;
    onChange(localDate(date));
    setOpen(false);
  };
  return (
    <div className="space-y-1">
      <label id={`${id}-label`} htmlFor={id} className="text-sm font-semibold">{label}</label>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button id={id} type="button" variant="outline" className="w-full justify-start font-normal" aria-labelledby={`${id}-label ${id}-value`} aria-invalid={invalid} aria-describedby={describedBy}>
            <CalendarDays className="h-4 w-4 text-slate-500" /><span id={`${id}-value`}>{selected ? formatDate(selected) : 'Any date'}</span>
          </Button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-auto p-0" aria-label={`Choose ${label.toLowerCase()} date`}>
          <Calendar mode="single" selected={selected} onSelect={selectDate} defaultMonth={selected} initialFocus captionLayout="dropdown-buttons" fromYear={1900} toYear={new Date().getFullYear() + 10} />
          <div className="flex items-center justify-between border-t border-slate-200 px-3 py-2">
            <Button type="button" size="sm" variant="ghost" onClick={() => selectDate(new Date())}>Today</Button>
            <Button type="button" size="sm" variant="ghost" disabled={!value} onClick={() => { onChange(''); setOpen(false); }}>Clear date</Button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
